import React from 'react';
import {
  Row,
  Col,
  Card,
  Descriptions,
  Avatar,
  Tag,
  Button,
} from 'antd';
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

interface LeadInfoSectionProps {
  lead: any;
  formatCurrency: (amount: number) => string;
  getPriorityColor: (priority: string) => string;
  renderInterestStatusTag: (interestStatus: string) => React.ReactNode;
}

export const LeadInfoSection: React.FC<LeadInfoSectionProps> = ({
  lead,
  formatCurrency,
  getPriorityColor,
  renderInterestStatusTag,
}) => {
  return (
    <Row gutter={[16, 16]}>
      {/* Lead Information */}
      <Col xs={24} lg={16}>
        <Card title="Informasi Lead">
          <Descriptions bordered column={2}>
            <Descriptions.Item label="Nama Lengkap">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Avatar icon={<UserOutlined />} style={{ marginRight: 8 }} />
                {lead.full_name}
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              {lead.email ? (
                <a href={`mailto:${lead.email}`}>
                  <MailOutlined style={{ marginRight: 4 }} />
                  {lead.email}
                </a>
              ) : '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Telepon">
              {lead.phone ? (
                <a href={`tel:${lead.phone}`}>
                  <PhoneOutlined style={{ marginRight: 4 }} />
                  {lead.phone}
                </a>
              ) : '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Alamat">
              {lead.alamat || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Tipe Properti">
              <Tag>{lead.property_type?.name}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Property Area">
              <Tag color="cyan">{lead.property_area?.name || 'N/A'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Budget">
              {formatCurrency(lead.budget)}
            </Descriptions.Item>
            <Descriptions.Item label="Prioritas">
              <Tag color={getPriorityColor(lead.lead_priority?.name)}>
                {lead.lead_priority?.name?.toUpperCase()}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Status Ketertarikan">
              {renderInterestStatusTag(lead.interest_status)}
            </Descriptions.Item>
            <Descriptions.Item label="Assigned To">
              {lead.assigned_to?.full_name || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Sumber Lead">
              <Tag color="blue">{lead.lead_source?.name}</Tag>
            </Descriptions.Item>
            {lead.lead_source?.name === 'Referral' && lead.referal && (
              <Descriptions.Item label="Nama Referral">
                {lead.referal}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Created By">
              {lead.created_by?.full_name}
            </Descriptions.Item>
            <Descriptions.Item label="Tanggal Dibuat">
              {dayjs(lead.created_at).format('DD MMM YYYY, HH:mm')}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>

      {/* Quick Contact Card */}
      <Col xs={24} lg={8}>
        <Card title="Quick Contact">
          <Button
            type="primary"
            icon={<PhoneOutlined />}
            size="large"
            block
            href={`https://wa.me/62${lead.phone}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ backgroundColor: '#25D366', borderColor: '#25D366', marginBottom: '12px' }}
          >
            Hubungi via WhatsApp
          </Button>
          <Button
            icon={<MailOutlined />}
            size="large"
            block
            href={`mailto:${lead.email}`}
          >
            Kirim Email
          </Button>
        </Card>
      </Col>
    </Row>
  );
};

export default LeadInfoSection;
